'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  ConditionGroupDto,
  CatalogModel,
} from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { CountryModel } from '@marketplace-web/country/country-data'

import usePricingRuleConditionsDataFormatter from '../../hooks/use-price-rule-conditions-data-formatter'
import PriceRuleDataRow from '../PriceRuleDataRow'

type Props = {
  factGroup: ConditionGroupDto
  countries?: Array<CountryModel> | null
  catalogs?: Array<CatalogModel>
  currencyCode: string
}

const FactGroupSection = ({ factGroup, countries, catalogs, currencyCode }: Props) => {
  const translate = useTranslate('available_discounts')
  const {
    any: { items },
  } = factGroup
  const priceRuleData = usePricingRuleConditionsDataFormatter({
    ruleConditions: items,
    countries,
    catalogs,
    currencyCode,
  })

  return priceRuleData.length > 0 ? (
    <div className="available_discounts__fact-group-section">
      <div className="available_discounts__pricing-rule-card-subtitle">
        {translate('price_rule_data.fact_group.label')}
      </div>
      {priceRuleData.map(ruleDataRow => (
        <PriceRuleDataRow key={ruleDataRow.label} ruleDataRow={ruleDataRow} />
      ))}
    </div>
  ) : null
}

export default FactGroupSection
